<div class="btn-group"
     dropdown
     appStopClickPropagation
     placement="bottom right"
     #dropdown="bs-dropdown">
    <button id="user-picture"
            dropdownToggle
            type="button"
            class="badge-secondary"
            aria-controls="dropdown-user-profile">
        <ui-user-profile-picture class="button-user-picture"
                                 [userInitials]="userInitials"
                                 [userPhoto]="userPhoto">
        </ui-user-profile-picture>
        <span class="icon-arrow-expand" [ngClass]="{'is-open': dropdown.isOpen}"></span>
    </button>
    <ul id="dropdown-user-profile" appStopClickPropagation *dropdownMenu class="dropdown-menu dropdown-menu-right"
        aria-labelledby="user-picture">
        <li>
            <div class="dropdown-top">
                <ui-user-profile-picture class="badge-secondary dropdown-user-picture"
                                         [userInitials]="userInitials"
                                         [userPhoto]="userPhoto">
                </ui-user-profile-picture>
                <div class="text-wrapper">
                    <div class="user-name">{{ user.fullName }}</div>
                    <!-- TODO remove next line after the roles will be implemented-->
                    <ng-container *ngFor="let role of user.userRoleName?.split(','); let last = last">
                        <div class="light-text">{{role.trim()}}{{last ? '' : ','}}</div>
                    </ng-container>
                </div>
            </div>
        </li>

        <li *ngIf="isProfileAvaliable">
            <a id="user-profile"
               appTrackClickButton
               dropdownToggle
               class="dropdown-item"
               [routerLink]="['/profile', user.userId]">
                <i class="icon-user-1"></i>
                My profile
            </a>
            <hr class="dropdown-menu-divider">
        </li>

        <ui-link-items [dropdown]="dropdown"></ui-link-items>
    </ul>
</div>
